import React from 'react';
import { Avatar, Chip, Grid, Icon, IconButton, Box, Breadcrumbs, Link, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { LocalStorange } from '../../environment';
import { useAppThemeContext, useAuthContext, useDrawerContext } from '../../contexts';
import { useTranslation } from 'react-i18next';
import type { ThemeName } from '../../contexts/ThemeContext';

interface ITopBarProps {
    title: string;
}

export const TopBar: React.FC<ITopBarProps> = ({ title }) => {
    const { handleToggleDrawer, isDrawerOpen } = useDrawerContext();
    const { handleSignOut } = useAuthContext();

    const storange: any = localStorage.getItem(LocalStorange.USERINFO);
    const userInfo = storange !== null ? JSON.parse(storange) : '';
    const name = userInfo !== '' ? userInfo.user.userName : '';

    const { handlerToggleTheme, themeName } = useAppThemeContext();
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Grid container >
                <Grid item xs={12} md={3}>
                    <Box display='flex' alignItems='center' gap={1}>
                        <IconButton
                            color='inherit'
                            aria-label='open drawer'
                            onClick={handleToggleDrawer}
                        >
                            {isDrawerOpen ? <Icon>menu_open</Icon> : <Icon>menu</Icon>}
                        </IconButton>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" href="/">
                                HOME
                            </Link>
                            <Typography color="text.primary">{title}</Typography>
                        </Breadcrumbs>
                    </Box>
                </Grid>
                <Grid item xs={12} md={9} >
                    <Box display='flex' alignItems='center' justifyContent='flex-end' gap={1}>
                        <Box sx={{ cursor: 'pointer' }} display='flex' alignItems='center' justifyContent='flex-end'>
                            <Chip
                                avatar={<Avatar  {...stringAvatar(name)} />}
                                label={name}
                                variant="outlined"
                            />
                        </Box>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2}>
                            <FormControl variant="outlined">
                                <InputLabel id="theme-selector-label">{ t('components.topBar.inputLabel.selectTheme') }</InputLabel>
                                <Select
                                    labelId="theme-selector-label"
                                    value={themeName}
                                    onChange={(event) => handlerToggleTheme(event.target.value as ThemeName)}
                                    label="Select Theme"
                                    size="small"
                                    sx={{ maxHeight: 32, minWidth: 100 }}
                                >
                                    <MenuItem value="light">{ t('components.topBar.menuItem.light') }</MenuItem>
                                    <MenuItem value="dark">{ t('components.topBar.menuItem.dark') }</MenuItem>
                                    {/* <MenuItem value="orange">Orange</MenuItem> */}
                                    {/* <MenuItem value="blue">Blue</MenuItem> */}
                                    {/* <MenuItem value="green">Green</MenuItem> */}
                                    <MenuItem value="gray">{ t('components.topBar.menuItem.gray') }</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box display='flex' alignItems='center' justifyContent='flex-end' gap={1}>
                            <IconButton
                                color='inherit'
                                onClick={handleSignOut}
                            >
                                <Icon>logout</Icon>
                            </IconButton>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}

function stringAvatar(name: string) {
    return {
        sx: {
            //bgcolor: stringToColor(name),
        },
        // children: name !== '' ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : '',
    };
}
